module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "com-container"
  }, [_c('div', {
    staticClass: "toolbar"
  }, [_c('h2', [_c('em'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.$t("changeEmail.title")))])])]), _vm._v(" "), _c('div', {
    staticClass: "cp-container"
  }, [_c('section', [_c('el-form', {
    ref: "chgEmailForm",
    attrs: {
      "model": _vm.chgEmailForm,
      "status-icon": "",
      "rules": _vm.chgEmailRule,
      "label-width": "150px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('changeEmail.password'),
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "autocomplete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.chgEmailForm.pass),
      callback: function($$v) {
        _vm.$set(_vm.chgEmailForm, "pass", $$v)
      },
      expression: "chgEmailForm.pass"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "email",
      "label": _vm.$t('changeEmail.newEmail')
    }
  }, [_c('el-input', {
    attrs: {
      "type": "email",
      "autocomplete": "off"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.chgEmailForm.email),
      callback: function($$v) {
        _vm.$set(_vm.chgEmailForm, "email", $$v)
      },
      expression: "chgEmailForm.email"
    }
  }, [_c('el-button', {
    attrs: {
      "slot": "append"
    },
    on: {
      "click": _vm.getVerifyCode
    },
    slot: "append"
  }, [_vm._v(_vm._s(_vm.$t("common.sendCode")))])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "code",
      "label": _vm.$t('common.verifyCode')
    }
  }, [_c('el-input', {
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.submitForm.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.chgEmailForm.code),
      callback: function($$v) {
        _vm.$set(_vm.chgEmailForm, "code", $$v)
      },
      expression: "chgEmailForm.code"
    }
  }), _vm._v(" "), _c('el-button', {
    staticClass: "cp-Btn",
    attrs: {
      "type": ""
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v(_vm._s(_vm.$t("common.submit")))])], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-728b97ae"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/AccountManagement/ChangeEmailAddress.vue
// module id = 985
// module chunks = 1